export default ['$rootScope', uiStateManagerHistoryService]
/*
 */
const localBufferKey = '_uiStateManagerHistoryServiceStore-LocalBuffer'
function uiStateManagerHistoryService($rootScope) {
  // Locate or build isolated scope with predefined data-structure....probably the closest thing to a
  //   struct in angular.
  let localBuffer =
    $rootScope[localBufferKey] ||
    function() {
      let localScope = $rootScope.$new(true)
      localScope.buffer = []
      return localScope
    }
  localBuffer = localBuffer()
  this.store = function uiStateManagerHistoryServiceStore(stateName, payload) {
    localBuffer.buffer.push([stateName, payload])
  }
  this.replayHistory = function uiStateManagerHistoryServiceReplayHistory(
    stateName,
    stateHandler
  ) {
    let replayCount = 100
    let replayTriggers = []
    for (
      let idx = localBuffer.buffer.length - replayCount;
      idx < localBuffer.buffer.length && idx > 0;
      idx++
    ) {
      replayTriggers.push(localBuffer.buffer[idx])
    }
    for (let idx = 0; idx < replayTriggers.length; idx++) {
      let [replayStateName, payload] = replayTriggers[idx]
      if (replayStateName === stateName) {
        stateHandler(payload)
      }
    }
  }
  $rootScope[localBufferKey] = function() {
    return localBuffer
  }
  return this
}
